const alcLnPain=[
    {
    label:"Site(s)",
    controlType:"checkbox group",
    options:["neck", "supraclavicular", "axillary", "groin"]
    },

    {
    label:"Severity",
    controlType:"radio button",
    options:["Mild", "Moderate", "Severe"]   
    },

    {
    label:"Frequency",
    controlType:"radio button",
    options:["Every day", "Most days", "Occasionally"]
    },
    

    { label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }
]

export default alcLnPain